<div  class="logo">
  <img [src]="logoUrl" style="width:auto" />
</div>
